// Consent decision logic: stored choices + regime → effective consent and banner requirement.

export const OPTIONAL_PURPOSES = ['analytics', 'marketing'];

/** Three-state choices: null = not decided, false = rejected, true = accepted. Functional is always on. */
export function choicesFromRecord(record) {
  return {
    functional: true,
    analytics: record ? record.choices.analytics : null,
    marketing: record ? record.choices.marketing : null,
  };
}

/**
 * What may run right now. A decision always wins. Undecided purposes are denied where explicit
 * consent is required; in opt-out regimes they are granted, except marketing when the regime
 * honors a Global Privacy Control signal and the browser sends one.
 */
export function resolveEffectiveConsent(choices, region, { gpc = false } = {}) {
  const granted = { functional: true };
  for (const purpose of OPTIONAL_PURPOSES) {
    const choice = choices[purpose];
    if (choice === true || choice === false) granted[purpose] = choice;
    else if (region.requireExplicitConsent) granted[purpose] = false;
    else granted[purpose] = !(purpose === 'marketing' && region.honorGpc && gpc);
  }
  return granted;
}

/** The banner opens when the regime shows one and there is no valid stored decision. */
export function isBannerRequired(region, record) {
  return region.showBanner && !record;
}
